import Navbar from './components/Navbar.jsx';
import Hero from './components/Hero.jsx';
import Offers from './components/Features.jsx';
import FAQ from './components/FAQ.jsx'
import ImageSlider from './components/ImageSlider.jsx'

import Footer from './components/Footer.jsx'

function App() {
  return (
    <div>
      <Navbar />
      <div id="hero-section">
      <Hero />
      </div>
      <div id="offers-section">
        <Offers />
      </div>
      <div id="image-slider-section">
        <ImageSlider />
      </div>
      <div id="faq-section">
        <FAQ />
      </div>
      <div id="footer-section">
        <Footer />
      </div>
    </div>
  );
}

export default App;
